(function() {
  var StepController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  StepController = App.loadClass('grower::Angular/Data/PlantingRx/StepController');

  exports.LayersController = (function(superClass) {
    extend(LayersController, superClass);

    function LayersController(scope, transitions, map, visualLayers, layerManager, loader) {
      var load_msg;
      this.scope = scope;
      this.transitions = transitions;
      this.map = map;
      this.visualLayers = visualLayers;
      this.layerManager = layerManager;
      this.loader = loader;
      this.reselectLayers = bind(this.reselectLayers, this);
      this.toggleLayer = bind(this.toggleLayer, this);
      LayersController.__super__.constructor.call(this, this.scope, this.transitions, this.map);
      if (this.scope.aborted) {
        return;
      }
      this.scope.available_layers = [];
      this.scope.toggleLayer = this.toggleLayer;
      load_msg = this.loader.overMapAndSidebar('Loading...');
      this.visualLayers.byField(this.scope.rx.fields_id, this.scope.rx.spp_id, this.scope.rx.year).then((function(_this) {
        return function(response) {
          _this.scope.available_layers = response.data.data.results;
          _this.scope.usable_layers = response.data.data.layers;
          _this.reselectLayers();
          return load_msg.hide();
        };
      })(this));
      this.setUpMap();
      this.scope.$watchCollection('rx.visual_layers', (function(_this) {
        return function(value) {
          if (value.length === 0) {
            return _this.scope.setValidity(false);
          } else {
            return _this.scope.setValidity(true);
          }
        };
      })(this));
    }

    LayersController.prototype.toggleLayer = function(layer) {
      var i, layersComparison, len, load_msg, ref, results, unique_visual_layer;
      if (layer.selected == null) {
        layer.selected = false;
      }
      layer.selected = !layer.selected;
      unique_visual_layer = {
        id: layer.id,
        type: layer.type,
        name: layer.name
      };
      if (layer.selected) {
        if (layer.map_service == null) {
          layer.map_service = this.layerManager.get(layer.type);
          layer.onSlide = function(ev, ui) {
            var ref;
            return (ref = layer.map_service) != null ? ref.setOpacity(ui.value) : void 0;
          };
        }
        load_msg = this.loader.overSidebar('Loading Layer...');
        layer.map_service.display({
          id: layer.id
        }, this.mapLayer).then((function(_this) {
          return function() {
            return load_msg.hide();
          };
        })(this))["catch"]((function(_this) {
          return function(response) {
            return load_msg.hide();
          };
        })(this));
        if (this.compareLayersToSelectedLayer(this.scope.rx.visual_layers, unique_visual_layer).length === 0) {
          return this.scope.rx.visual_layers.push(unique_visual_layer);
        } else {
          layersComparison = this.compareLayersToSelectedLayer(this.scope.rx.visual_layers, layer);
          results = [];
          for (i = 0, len = layersComparison.length; i < len; i++) {
            layer = layersComparison[i];
            results.push(layer.name = unique_visual_layer.name);
          }
          return results;
        }
      } else {
        if ((ref = layer.map_service) != null) {
          ref.hide(this.mapLayer);
        }
        return _.remove(this.scope.rx.visual_layers, {
          id: unique_visual_layer.id,
          type: unique_visual_layer.type
        });
      }
    };

    LayersController.prototype.reselectLayers = function() {
      var i, layer, len, ref, results, selected_layer;
      ref = this.scope.rx.visual_layers;
      results = [];
      for (i = 0, len = ref.length; i < len; i++) {
        selected_layer = ref[i];
        if ((selected_layer.type != null) && (selected_layer.id != null)) {
          results.push((function() {
            var j, len1, ref1, results1;
            ref1 = this.compareLayersToSelectedLayer(this.scope.available_layers, selected_layer);
            results1 = [];
            for (j = 0, len1 = ref1.length; j < len1; j++) {
              layer = ref1[j];
              results1.push(this.toggleLayer(layer));
            }
            return results1;
          }).call(this));
        }
      }
      return results;
    };

    LayersController.prototype.compareLayersToSelectedLayer = function(layers, selected_layer) {
      return _.filter(layers, {
        type: selected_layer.type,
        id: selected_layer.id
      });
    };

    return LayersController;

  })(StepController);

}).call(this);
